module.exports = __webpack_public_path__ + "static/media/1_day.98b53d6d.svg";